/**
 * For dates getting the name of it's timezone
 * @param date
 */
export const getTimezoneName = (date: Date): string => {
  const short = date.toLocaleDateString(undefined);
  const full = date.toLocaleDateString(undefined, { timeZoneName: "short" });
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, "");
  } else {
    return full;
  }
};
